module.exports = __webpack_public_path__ + "img/home-background.82966ad6.jpg";